﻿window.cObjetPlanitiMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetTableUpdateLib = function () { return ["planiti"] }

    this.color = "#69a64c"
    this.mGetLibBase = function () { return "Planiti"; }
    this.mGetAttributBase = function () { return "le" }
    this.mGetNewLib = function () { return "Nouveau planiti"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') { txt = ((objet.data.nom) ? objet.data.nom : "(aucun nom pour le planiti)") }
        else {
            txt = "Planiti"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-share-nodes' title='Planiti'></i>");
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {

        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        if (dataTemplate.ferme == '1') $Table.css("text-decoration", "line-through")
        var $Tr = $("<tr/>").appendTo($Table)

        var $TdUti = $("<td style='width:30px;padding:0 3px;height:22px;'/>").appendTo($Tr)
        $("<div style='width:100%;height:100%;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgSimpleStrConUti({
            bddCtrl: objet.bddRef,
            idTable: objet.bddRef.getObjet("utilisateur").mGetTable().id_table,
            id: dataTemplate.id_utilisateur,
            text: objet.bddRef.getObjet("utilisateur", dataTemplate.id_utilisateur).mGetLib1()
        })

        var $TdNom = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;font-weight:bold;'>" + ((dataTemplate.nom == null) ? "" : dataTemplate.nom) + "</td>").appendTo($Tr)

        var $Tr = $("<tr/>").appendTo($Table)
        $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;font-style:italic;' colspan='2'>" + ((dataTemplate.description == null) ? "" : dataTemplate.description) + "</td>").appendTo($Tr)

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus, option) {
        $("<span style='' title ='" + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
        //if (dataPlus.dcr.getTime() == dataPlus.dmo.getTime()) {
        //    $("<span style='font-family:barlow condensed;' title ='" + dataPlus.dcr.toFrenchDateTime() + "'>Créé<br/>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
        //} else {
        //    $("<span style='font-family:barlow condensed;'>Créé " + dataPlus.dcr.toDateIlya(true) + " (" + dataPlus.dcr.toFrenchDateTime() + ") &bull; Modifié " + dataPlus.dmo.toDateIlya(true) + " (" + dataPlus.dmo.toFrenchDateTime() + ")</span>").appendTo(contentElement)
        //}
    }

    this.isPopupFullScreen = false
    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        var dxCtrl = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentPlaniti({
            bddCtrl: objet.bddRef,
            data: objet.data,
            optionPopup: option
        }).dxCtrlContentPlaniti("instance")
    }

    this.mGetWidthPopup = function () { return 500 }
    this.mGetFullScreenPopup = function () { return false }

}